import React from "react";
import styles from "../components/laymanComp_css/LaymanPage35.module.css";
import { Link } from "@mui/material";

export default function LaymanPage35() {
  return (
    <>
      <div className={styles.layman_block_2}>
        <div className={styles.block1_main_wrpr}>
          <div className={styles.block1_main_bg}>
            <div className={styles.common_width_1}>
              <div className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}>
                <div className={styles.column}>
                  <div className={`${styles.col12} ${styles.bgifive}`}>
                    <h1>ARCHETYPE OF LIBRA</h1>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.common_width}>
              <div className={styles.layman_yin_yang_block_main_wrpper}>
                <div className={`${styles.archetype_libra_block1_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/ARCHETYPE_OF_LIBRA/as_libra_block1_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/ARCHETYPE_OF_LIBRA/as_libra_block1_img.webp`}/>    
                  </div>
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <div className={styles.layman_yellow_commn_header}>
                        <h2>
                          The Harmonious Dance of Libra: Balancing the Cosmic
                          Scales
                        </h2>
                      </div>
                      <p>
                        Libra, a Cosmic Archetype {" "}
                        in the tapestry of <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being </Link>
                        method and Archetypal Astrology, reveals itself as a
                        Cardinal Air Influence—a captivating interplay of
                        equilibrium and rationality within the cosmic dance.
                      </p>

                      <p>
                        <strong>The Cardinal Air Enigma</strong>
                        <br />
                        Intriguingly placed in a cardinal position, Libra
                        embodies the <span><i>"initial onrush"</i></span> of the{" "}
                        Air element. Air, at its zenith, represents
                          philosophy, science, logical judgment, and
                          rationality.{" "}
                        Libra's cardinal nature, however, takes this a step
                        further—it signifies the pursuit of perfect balance and
                        measurement, creating a unified field of equilibrated
                        opposites. At the core of Libra's essence lies the quest
                        for equilibrium, an ever-present force as we navigate
                        the fringes of the unknown, balancing our conditioned
                        experiences against new insights.
                      </p>
                      <p>
                        <strong>A Dance in the Suprarational Realm</strong>{" "}
                        <br />
                        Libra's influence extends beyond the bounds of
                        conventional logic, delving into the seemingly
                        irrational and illogical facets of the psyche—the realm
                        where Magick thrives and intuitive precognition
                        flourishes.{" "} Libra, in its cardinal Air nature, orchestrates{" "}
                        a <span><i>"Suprarational Knowing,"</i></span> where these
                        esoteric forces become not only practical but
                        indispensable.
                      </p>
                      <p>
                        <strong>Lady Justice and Divine Order</strong>
                        <br />
                        Personifying the Greek Themis as Lady Justice, Libra
                        instills a commitment to divine order, fairness, and
                        adherence to natural laws. It calls for the observance
                        of healthy customs and elevates us to high personal
                        standards. In the Thoth deck, Libra assumes the guise of{" "}
                        <span><i>"Adjustment"</i></span>, a departure from the
                        traditional <span><i>"Judgment"</i></span> card. It is not an
                        entombed finality but a perpetual course correction—a
                        constant refocusing towards the pinnacle of rational
                        thought.
                      </p>
                    </div>
                  </div>
                </div>

                <div className={`${styles.archetype_libra_block2_wrpr} ${styles.flex} ${styles.cmmn_mrgn} `}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/ARCHETYPE_OF_LIBRA/as_libra_block2_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/ARCHETYPE_OF_LIBRA/as_libra_block2_img.webp`}/> 
                  </div>

                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={styles.layman_txt_box_innr}>
                      <p className={styles.one_sqr_bullt}>
                        <strong>Seeking the Logos in Cosmic Ingression</strong>
                        <br />
                        To embrace the influence of Libra is to commit to
                        personal truth and fairness. Ruled in secrecy by Venus,
                        the highest manifestation of Libra's influence lies in
                        human compassion. Working under Libra's guidance demands
                        the removal of the tumultuous waves of crashing
                        emotions, replacing them with clear, calm, and{" "}
                          compassionate decision-making—a thoughtful charting of
                          one's course.
                      </p>

                      <p>
                        As we immerse ourselves in the harmonious dance of
                        Libra, we discover the transformative power of
                        equilibrium and the radiant brilliance that emanates
                        from a cosmos perfectly balanced in its cosmic scales.
                      </p>

                      <div class={styles.layman_yellow_commn_header}>
                        <h2>Astrological Features:</h2>
                      </div>
                      <div className={styles.bullet_wrapper}>
                        <p>
                          <strong>Cosmic Archetype:</strong> Libra is a
                            {" "}
                            significant Cosmic Archetype{" "}
                          within <Link href="https://www.divineinfinitebeing.com">the School of Divine Infinite Being</Link> method and
                          Archetypal Astrology, representing Cardinal Air
                          Influence.
                        </p>
                        <p>
                          <strong>Cardinal Air Nature:</strong> As a Cardinal
                          Air Influence, Libra embodies the{" "}
                          <span><i>"initial onrush"</i></span> of the Air element,
                          emphasizing perfect balance, measurement, and a
                          unified field of equilibrated opposites.
                        </p>
                        <p>
                          <strong>Philosophy and Science:</strong> The highest
                          expression of{" "}Air—philosophy, science, logical judgment,{" "}
                          and rationality—is inherent in Libra's nature, guiding
                          individuals to navigate the unknown with balance and
                          rational thinking.
                        </p>
                        <p>
                          <strong>Suprarational Knowing:</strong> Libra
                          transcends conventional logic, reaching into the
                          suprarational realm where{" "}
                            Magick thrives{" "}
                          and intuitive precognition becomes practical and
                          indispensable.
                        </p>
                        <p>
                          <strong>Personification of Lady Justice:</strong>{" "}
                          Libra personifies{" "}
                            {" "}
                            Lady Justice,{" "}
                          embodying a commitment to divine order, fairness,
                          natural law, and adherence to healthy customs.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={`${styles.archetype_libra_block3_wrpr} ${styles.flex} ${styles.cmmn_mrgn}`}>
                  <div className={styles.layman_img_box_wrpr}>
                    {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/ARCHETYPE_OF_LIBRA/as_libra_block3_img.webp" /> */}
                    <img src={`${process.env.cloud_url}Layman-Symbolism/ARCHETYPE_OF_LIBRA/as_libra_block3_img.webp`}/> 
                  </div>
                  <div className={styles.layman_txt_box_wrpr}>
                    <div className={`${styles.layman_txt_box_innr} ${styles.bullet_wrapper}`}>
                      <p>
                        <strong> High Personal Standards:</strong> Libra demands
                        high personal standards, urging continuous
                        self-adjustment and adherence to the principles of{" "}
                          Themis—Lady Justice.
                      </p>
                      <p>
                        <strong>Thoth Tarot - Adjustment:</strong> In the{" "}
                        Thoth Tarot,{" "}
                        Libra is represented by <span><i>"Adjustment"</i></span>,
                        emphasizing an ongoing process of course correction and
                        a constant refocusing towards the highest standards of
                        rational thought.
                      </p>
                      <p>
                        <strong>Logos and Cosmic Ingression:</strong> Working
                        under the influence of Libra involves seeking the Logos
                        or patterning intelligence in the Cosmic Ingression of
                        experience, aligning oneself with rationality in the
                        pursuit of meaning.
                      </p>

                      <p>
                        <stong><b>Venus Rulership:</b></stong> Secretly ruled by Venus,
                        Libra's influence extends to human compassion, requiring
                        individuals to navigate their decisions with clear,
                        calm, and compassionate discernment.
                      </p>

                      <p>
                        <strong>Equilibrium and Balance:</strong> Libra's
                        essence lies in{" "} the harmonious dance of equilibrium, balancing{" "}
                        opposing forces in the cosmic scales to achieve a
                        radiant brilliance in the cosmic tapestry.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={`${styles.green_sec_cmn_main_wrp} ${styles.veneration_green_wrapper}`}>
            <div className={styles.common_width}>
              <Link href="/rota-the-wheel">
                <div className={styles.green_sec_cmn_sub_wrp}>
                  <h1>
                    The Astrological Tarot association for Libra is
                    <br /> The Adjustment. See our alchemical ROTA here
                  </h1>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* <div className={styles.demo_image}>
              <div className={styles.block1_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_libra/layman_page35_block1_demo_img.webp'></img>
              </div>

              <div className={styles.block2_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_libra/layman_page35_block2_demo_img.webp'></img>
              </div>

              <div className={styles.block3_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_libra/layman_page35_block3_demo_img.webp'></img>
              </div>

              <div className={styles.block4_demo_img}>
                <img src='https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/Layman-Symbolism/layman_page_libra/layman_page35_block4_demo_img.webp.webp'></img>
                <Link className={styles.blank_link} href="/rota-the-wheel"></Link>
              </div>
        </div> */}
    </>
  );
}
